// import { combineReducers, configureStore } from "@reduxjs/toolkit";
// import { persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
// import fxRateSlice from './Reducer/FX_Rate_Reducer'
// import remitterReducer from './Reducer/Remitter'
// import { confirmPhoneVerifySlice, phoneVerifySlice } from './Reducer/PhoneVerify'
// import configSlice from './Reducer/Config'
// import docReducer from './Reducer/docReducer'
// import ocrReducer from './Reducer/ocrReducer'
// import paymentReducer from './Reducer/payment'
// import { transactionSlice } from './Reducer/transaction'



// const rootReducer = combineReducers({
//     fxRate: fxRateSlice,
//     remitter: remitterReducer,
//     phoneverify: phoneVerifySlice,
//     confirmPhoneVerify: confirmPhoneVerifySlice,
//     transaction: transactionSlice,
//     payment: paymentReducer,
//     config: configSlice,
//     documents: docReducer,
//     ocr: ocrReducer,

// })

// const persistConfig = {
//     key: 'root',
//     storage,
// };

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// export const store = configureStore({
//     reducer: persistedReducer,
// });


import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import fxRateSlice from './Reducer/FX_Rate_Reducer';
import remitterReducer from './Reducer/Remitter';
import { confirmPhoneVerifySlice, phoneVerifySlice } from './Reducer/PhoneVerify';
import configReducer from './Reducer/Config';
import docReducer from './Reducer/docReducer';
import ocrReducer from './Reducer/ocrReducer';
import paymentReducer from './Reducer/payment';
import { transactionSlice } from './Reducer/transaction';
import  beneficiaryReducer  from "./Reducer/beneficiary";
import userReducer from "./Reducer/UserReducer";
import kycReducer from "./Reducer/Kyc";


const rootReducer = combineReducers({
    user: userReducer,
    fxRate: fxRateSlice,
    remitter: remitterReducer,
    phoneverify: phoneVerifySlice,
    confirmPhoneVerify: confirmPhoneVerifySlice,
    transaction: transactionSlice,
    beneficiary: beneficiaryReducer,
    kyc:kycReducer,
    payment: paymentReducer,
    config: configReducer,
    documents: docReducer,
    ocr: ocrReducer,
});

const persistConfig = {
    key: 'root',
    storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: process.env.NODE_ENV !== 'production' ? false : true,
    }),
});
